// device-uuid.service.ts
import { Injectable } from '@angular/core';
import { DeviceUUID } from 'device-uuid';

@Injectable({
  providedIn: 'root'
})
export class DeviceUuidService {
  private readonly storageKey = 'device-uuid';

  constructor() {}

  getDeviceUuid(): string {
    let uuid = localStorage.getItem(this.storageKey);
    if (!uuid) {
      const deviceUUID = new DeviceUUID();
      uuid = deviceUUID.get();
      localStorage.setItem(this.storageKey, uuid);
    }
    return uuid;
  }
}
